export const COMPONENT_NAME = 'PageHeading';
